export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.hook('vuetify:ssr-client-hints', ({ vuetifyOptions, ssrClientHints, ssrClientHintsConfiguration }) => {
        // your logic here
        // vuetifyOptions is the Vuetify options object
        // ssrClientHints is the detected client hints
        // ssrClientHintsConfiguration is the configuration object
        ssrClientHints.reloadOnFirstRequest = true;
    })
})
